import {
	loopFocus,
	gaEvent,
} from '../../js/utils';

const navigation = () => {
	const el = document.querySelector('.c-navigation');
	const elActiveClass = 'c-navigation--active';
	const outerEl = document.querySelector('.c-site-header');
	const outerElPinnedClass = 'c-site-header--pinned';
	const outerElPinnedCompleteClass = 'complete';
	const documentActiveClass = 'c-body--active';
	const toggleEl = document.querySelector('.e-menu-toggle');
	const toggleLabel = toggleEl ? toggleEl.querySelector('.c-navigation__toggle-label') : undefined;
	const items = document.querySelectorAll('.c-navigation__list-item[aria-haspopup]');
	const itemActiveClass = 'c-navigation__list-item--active';
	const itemInactiveClass = 'c-navigation__list-item--inactive';
	let lastScrollTop = 0;
	const isMobile = navigator.userAgent.match(/Mobi/);
	const navLinks = document.querySelectorAll('.c-site-header a');

	if (isMobile) {
		document.body.classList.add('c-body--mobile');
	}

	if (outerEl && !isMobile) {
		window.addEventListener('scroll', () => {
			const currentScroll = window.pageYOffset;

			// Remove pinned state, if at very top of page
			if (currentScroll === 0) {
				outerEl.classList.remove(outerElPinnedClass);
			} else {
				outerEl.classList.add(outerElPinnedClass);
			}

			// if user is scrolling down
			if (
				currentScroll > lastScrollTop
				&& outerEl.classList.contains(outerElPinnedCompleteClass)
			) {
				// remove transition completed class
				outerEl.classList.remove(outerElPinnedCompleteClass);

			// otherwise, if user is scrolling up
			} else if (
				currentScroll < lastScrollTop
				&& !outerEl.classList.contains(outerElPinnedCompleteClass)
			) {
				// add transition completed class
				outerEl.classList.add(outerElPinnedCompleteClass);
			}

			lastScrollTop = currentScroll;
		});
	}

	const handleToggleClick = (close) => {
		const navInner = el.querySelector('.c-navigation__menu');

		// toggle the navigation's active class
		el.classList.toggle(elActiveClass);

		const isActive = el.classList.contains(elActiveClass);

		// Also, update screen reader attribute if applicable
		navInner.setAttribute('aria-hidden', !isActive);

		if (close || !isActive) {
			// If it's not active, reset hidden attribute
			navInner.setAttribute('hidden', true);

			if (toggleLabel) {
				toggleLabel.innerText = toggleEl.getAttribute('data-label-default');
			}

			const listItems = navInner.querySelectorAll('.c-navigation__list-item');
			const section = navInner.querySelectorAll('.c-navigation__section');

			// Reset everything else
			section.forEach((s) => {
				s.classList.remove('children-active');
				s.setAttribute('hidden', true);
				s.setAttribute('aria-hidden', true);
			});

			listItems.forEach((li) => {
				li.classList.remove(itemActiveClass);
				li.classList.remove(itemInactiveClass);
				li.setAttribute('hidden', true);
				li.setAttribute('aria-hidden', true);
			});
		} else {
			// else remove the hidden attribute
			navInner.removeAttribute('hidden');

			if (toggleLabel) {
				toggleLabel.innerText = toggleEl.getAttribute('data-label-close');
			}

			// Trap focus to active navigation window
			const activeNavEl = document.querySelectorAll('.c-navigation--active, .c-navigation--active .c-navigation__section');

			if (activeNavEl.length > 0) {
				Array.from(activeNavEl).forEach((e) => {
					loopFocus({
						el: e,
						FOCUSABLE_ELEMENT_SELECTORS: 'a[href], button',
					});
				});
			}
		}

		// update screen reader arribute
		toggleEl.setAttribute('aria-expanded', isActive);

		// toggle the body active class for applying overflow styles
		document.body.classList.toggle(documentActiveClass);
	};

	// close navigation when clicking off main list
	const navigationOffTarget = document.querySelector('.c-navigation__off-target');
	if (navigationOffTarget) {
		navigationOffTarget.addEventListener('click', () => handleToggleClick(true));
	}

	if (el && toggleEl) {
		// When user clicks toggle button
		toggleEl.addEventListener('click', () => handleToggleClick());

		// When user clicks ESC
		// TODO: this needs improving
		document.body.addEventListener('keydown', (e) => {
			// console.log(e);
			if (e.keyCode === 27 && el.classList.contains(elActiveClass)) {
				handleToggleClick(true);
			}
		});
	}

	if (items.length) {
		items.forEach((item) => {
			const toggle = item.querySelector('.c-navigation__subtoggle');
			const section = item.querySelector('.c-navigation__section');
			const close = section.querySelector('.c-navigation__section-subtitle');

			// when user clicks a dropdown arrow
			toggle.addEventListener('click', (e) => {
				e.preventDefault();

				// add active class to corresponding item
				item.classList.add(itemActiveClass);
				section.removeAttribute('hidden');
				section.setAttribute('aria-hidden', false);

				// also add active class to grandparent
				// if grandparent exists, and is a section
				// then we will hide the navigation for that section to prevent two showing
				item.parentNode.parentNode.classList.add('children-active');

				// iterate over all items on this level
				for (const sibling of item.parentNode.children) {
					// if not this item, it will be a sibling element
					if (sibling !== item) {
						// add inactive class to hide
						sibling.classList.add(itemInactiveClass);

						// also hide from screen readers
						sibling.setAttribute('hidden', true);
						sibling.setAttribute('aria-hidden', true);
					}
				}
			});

			// When a user clicks a section close button
			close.addEventListener('click', () => {
				// remove active class from item
				item.classList.remove(itemActiveClass);
				section.setAttribute('hidden', true);
				section.setAttribute('aria-hidden', true);

				// remove actuve class from grandparent
				item.parentNode.parentNode.classList.remove('children-active');

				// iterate item's siblings and remove attrs to hide from SR's
				for (const sibling of item.parentNode.children) {
					if (sibling !== item) {
						sibling.classList.remove(itemInactiveClass);
						sibling.removeAttribute('hidden');
						sibling.setAttribute('aria-hidden', false);
					}
				}
			});
		});
	}

	// Navigation tagging tracking
	if (navLinks.length) {
		navLinks.forEach((navLink) => {
			let linkText = navLink.innerText.trim();
			if (linkText === '') {
				if (navLink.hasAttribute('title')) {
					linkText = navLink.getAttribute('title').trim();
				}
			}
			if (linkText !== '') {
				navLink.addEventListener('click', () => {
					gaEvent({
						event: 'navigationInteraction',
						eventCategory: 'Navigation',
						eventAction: 'Main menu',
						eventLabel: linkText
					});
				});
			}
		});
	}
};

export default navigation;
